import React from "react";

function transposeText(text: string): string {
  return text.replace(/[А-Яа-яЁёA-Za-z|]+/g, (word) => {
    if (!word.includes("|")) return word.toLowerCase();

    return word.split("|").reverse().join("|").toLowerCase();
  });
}
type RenderBoardProps = {
  gameRounds: {
    textBySyllables: string[];
    correctAnswer: string;
  }[];
  roundCount: number;
  showSyllables: boolean;
};
const RenderBoard = ({
  gameRounds,
  roundCount,
  showSyllables,
}: RenderBoardProps) => {
  const currentRound = gameRounds[roundCount];
  const transposedText = currentRound.textBySyllables.map(transposeText);

  return (
     <div className="transpos-board-grid">
      {transposedText.map((line, index) => (
        <div key={index} className="transpos-text-line">
          {showSyllables ? (
            line.split("|").map((part, i, arr) => (
              <React.Fragment key={i}>
                {part}
                {i < arr.length - 1 && (
                  <span className="transpos-divider">|</span>
                )}
              </React.Fragment>
            ))
          ) : (
            line.replace(/\|/g, "")
          )}
        </div>
      ))}
    </div>
  );
};
export default RenderBoard;
